import template from './authorized-outside-person.html';

export class AuthorizedOutsidePersonController {
  constructor($log, $mdDialog, $filter, PinCodeService) {
    'ngInject';
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$filter = $filter;
    this.PinCodeService = PinCodeService;

    this.date = new Date();
    this.authorizedOutsidePersons = [];
    this.loading = true;
  }

  $onChanges(changes) {
    if (changes.student) {
      this.student = {...this.student};
    }
  }

  $onInit() {
    this.PinCodeService.getAuthorizedOutsidePerson(
      this.student.studentUserId,
      {
        currentDay: this.$filter('date')(this.date, 'yyyy-MM-dd')
      }
    ).then(result => {
      this.loading = false;
      this.authorizedOutsidePersons = result;
    });
  }

  unregisterStudent(outsidePerson) {
    this.$mdDialog.hide(outsidePerson);
  }

  closeDialog() {
    this.$mdDialog.cancel();
  }
}

export const AuthorizedOutsidePerson = {
  bindings: {
    student: '<'
  },
  controller: AuthorizedOutsidePersonController,
  template
};
